import qs from 'qs';
import useAPI from '../core/hooks/useApi';

export const useGetQuestionsByOptInId = optInId =>
  useAPI(`/api/questions?${qs.stringify({ optInId })}`);
